import React from 'react';

import { Controller, Control } from 'react-hook-form';

import { Dropdown } from 'components/form';

type Item<T> = {
  label: string;
  value: T;
};

type Props<T> = {
  control: Control<any>;
  errorMessage?: string[] | null;
  name: string;
  items: Item<T>[];
  isFullWidth?: boolean;
  placeholder?: string;
  label?: string;
  fixedLabel?: boolean;
  doTranslation?: boolean;
  disabled?: boolean;
  ariaLabel?: string;
  onValueChange?: any;
  isRequired?: boolean;
  testId?: string;
  returnValueOnly?: boolean;
};

export function HookFormDropdown<T>({
  control,
  name,
  items,
  placeholder,
  isFullWidth,
  label,
  fixedLabel,
  ariaLabel,
  doTranslation,
  disabled,
  onValueChange,
  isRequired = false,
  testId,
  returnValueOnly = false,
}: Props<T>) {
  return (
    <Controller
      control={control}
      name={name}
      rules={{ required: isRequired }}
      render={({ field: { onChange, value } }) => (
        <Dropdown
          onChange={e => {
            onChange(returnValueOnly ? e.value : e);

            if (onValueChange) {
              onValueChange(returnValueOnly ? e.value : e);
            }
          }}
          value={value}
          items={items}
          placeholder={placeholder}
          isFullWidth={isFullWidth}
          ariaLabel={ariaLabel}
          label={label}
          fixedLabel={fixedLabel}
          doTranslation={doTranslation}
          disabled={disabled}
          isRequired={isRequired}
          testId={testId ?? ''}
        />
      )}
    />
  );
}

export default HookFormDropdown;
